import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ModuleName } from 'src/app/middleware/common/Enum/common.enum';
import { AddEmailActionComponent } from 'src/app/middleware/common/addEmailAction/addEmailAction.component';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { AddCustomInfoComponent } from 'src/app/middleware/common/addCustomInfo/addCustomInfo.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { AddTouchesComponent } from 'src/app/middleware/common/addtouches/addtouches.component';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
@Component({
  selector: 'app-customInfo3c',
  templateUrl: './customInfo3c.component.html',
  styleUrls: ['./customInfo3c.component.scss']
})
export class CustomInfo3cComponent implements OnInit, OnDestroy {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any = [];
  myOfficeID: any;

  @Input() mainModulename: string = "";
  getTagListResponseHolder: any;

  AllCustomInfoList: any[] = [];
  AllCustomInfoListShow: boolean = false;
  CustomInfoTypeForFilter: any[] = [];
  CustomInfoType: any[] = [];

  // Client-side keyword filter for the notes list (UI only; the type filter still hits the API)
  searchText: string = '';

  matchesSearch(touch: any): boolean {
    const q = (this.searchText || '').trim().toLowerCase();
    if (!q || !touch) {
      return true;
    }
    const haystack = [
      touch.customNote,
      touch.customNoteTypeName,
      touch.customNoteStatusName,
      touch.createdByFirstName,
      touch.createdByLastName
    ].filter((v: any) => v != null).join(' ').toLowerCase();
    return haystack.indexOf(q) !== -1;
  }

  hasSearchMatches(): boolean {
    return (this.AllCustomInfoList || []).some((t: any) => this.matchesSearch(t));
  }

  constructor(private dialog: MatDialog, private taskService: SettingService,
    private statusConst: StatusConstant, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private loaderService: LoaderService,
    private toastr: ToastrService, private sanitizer: DomSanitizer,
    private coreService: CoreService, private _dataSharingService: DataSharingService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach((oe: any) => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

  ngOnInit(): void {
    this.mainModulename;
    this.GetAllCustomInfos();

    if (this.showNotes) {
      const menuModulesList = JSON.parse(sessionStorage.getItem('menuModules') || '[]');
      const coreModule = menuModulesList.filter((x: any) => x.mainModuleName == 'Core');
      this.notesFolderId = coreModule.length > 0 ? coreModule[0].folderID : 0;
      this.getAllNotes();
      // previous / next record in the header reloads the notes, as the old Notes tab did
      this.nextPreviousSub = this._dataSharingService.getNextPreviousForTouchesFromCore().subscribe((result) => {
        if (result) {
          this.getAllNotes();
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.nextPreviousSub?.unsubscribe();
  }

  /* ---- Notes (left column, resident records only) --------------------------
     Same API and dialogs as the core Notes tab (app-touches). */

  get showNotes(): boolean {
    return this.mainModulename == 'Core';
  }

  private nextPreviousSub: Subscription;
  private notesFolderId: number = 0;
  AllNotes: any[] = [];
  /** Number of notes, for the record tab badge. */
  @Output() countChange = new EventEmitter<number>();
  notesLoaded: boolean = false;
  NoteTypes: any[] = [];
  noteSearch: string = '';
  noteTypeFilter: string = '';

  get filteredNotes(): any[] {
    const q = (this.noteSearch || '').trim().toLowerCase();
    return (this.AllNotes || []).filter((n: any) => {
      if (this.noteTypeFilter && n.touchTypeName != this.noteTypeFilter) return false;
      if (!q) return true;
      const haystack = [n.touchNote, n.touchTypeName, n.touchStatusName, n.createdByFirstName, n.createdByLastName]
        .filter((v: any) => v != null).join(' ').toLowerCase();
      return haystack.indexOf(q) !== -1;
    });
  }

  getAllNotes() {
    const ReqModel = {
      folderID: this.notesFolderId,
      transactionID: Number(sessionStorage.getItem('transactionID')),
      documentID: null,
      databaseId: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList,
    };
    this.coreService.GetAllCoreTouches(ReqModel).subscribe(response => {
      this.notesLoaded = true;
      if (response?.status == this.statusConst.statusSuccess) {
        const list = response.data || [];
        list.forEach((res: any) => {
          if (res.createdByLastName != null) {
            res.createdByFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.createdByFirstName);
            res.createdByLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.createdByLastName);
          }
          if (res.byPortal != null) {
            res.createdByFirstName = res.byPortal.split('@')[0];
          }
          if (res.touchNote != null) {
            const withBreaks = res.touchNote.replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>');
            res.touchNoteNew = this.makeLinksClickable(withBreaks);
          }
        });
        this.AllNotes = list;
        this.countChange.emit(list.length);
        if (this.NoteTypes.length == 0) {
          this.getNoteTypes();
        }
      } else {
        this.AllNotes = [];
        this.countChange.emit(0);
      }
    }, () => {
      this.notesLoaded = true;
    });
  }

  getNoteTypes() {
    const ReqModel = {
      databaseId: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
    };
    this.taskService.getAllTouchTypeList(ReqModel).subscribe((response: any) => {
      if (response?.status == this.statusConst.statusSuccess) {
        // the API can repeat a type; keep one per name
        const seen: { [name: string]: boolean } = {};
        this.NoteTypes = (response.data || []).filter((t: any) => {
          const key = (t.touchName || '').trim().toLowerCase();
          if (!key || seen[key]) return false;
          seen[key] = true;
          return true;
        });
      }
    });
  }

  addNote() {
    const dialogRef = this.dialog.open(AddTouchesComponent, {
      data: { moduleName: 'Core', folderID: 1, documentID: null },
      panelClass: 'autoFill-modalbox'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getAllNotes();
      }
    });
  }

  editNote(note: any) {
    const dialogRef = this.dialog.open(AddTouchesComponent, {
      data: { moduleName: 'Core', folderID: 1, documentID: null, touch: note },
      panelClass: 'autoFill-modalbox'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getAllNotes();
      }
    });
  }

  deleteNote(note: any) {
    const dialogData = new ConfirmDialogModel('Confirm Delete', 'Are you sure you want to delete this note ?', 'Delete');
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe((dialogResult) => {
      if (!dialogResult) return;
      const model = {
        touchesID: [note.touchID],
        transactionID: Number(sessionStorage.getItem('transactionID')),
        databaseId: Number(this.databaseId),
        organizationID: Number(this.organizationId),
        userID: this.currentUser.UID,
        officeID: this.myOfficeID
      };
      this.coreService.DeleteCoreTouch(model).subscribe(response => {
        if (response?.status == this.statusConst.statusSuccess) {
          this.toastr.success('Deleted successfully.', '', { timeOut: 3000 });
          this.getAllNotes();
        }
      });
    });
  }

  // icon + colour per note type name
  typeIcon(typeName: any): string {
    const t = ((typeName || '') + '').toLowerCase();
    if (t.indexOf('email') !== -1) { return 'mail'; }
    if (t.indexOf('phone') !== -1 || t.indexOf('call') !== -1) { return 'call'; }
    if (t.indexOf('meeting') !== -1) { return 'groups'; }
    if (t.indexOf('log') !== -1) { return 'history'; }
    if (t.indexOf('note') !== -1) { return 'sticky_note_2'; }
    return 'event_note';
  }

  typeTone(typeName: any): string {
    const t = ((typeName || '') + '').toLowerCase();
    if (t.indexOf('email') !== -1) { return 'rose'; }
    if (t.indexOf('phone') !== -1 || t.indexOf('call') !== -1) { return 'green'; }
    if (t.indexOf('meeting') !== -1) { return 'violet'; }
    if (t.indexOf('note') !== -1) { return 'amber'; }
    return 'blue';
  }

  initials(first: any, last: any): string {
    const f = ((first || '') + '').trim();
    const l = ((last || '') + '').trim();
    const v = (f ? f[0] : '') + (l ? l[0] : '');
    return v ? v.toUpperCase() : '?';
  }


  // get Get AllCustom Info list
  GetAllCustomInfos() {
    var cType = 0;
    if (this.mainModulename == "Core") {
      cType = 1;
    }
    if (this.mainModulename == "Contact") {
      cType = 2;
    }
    if (this.mainModulename == "Company") {
      cType = 3;
    }
    var ReqModel = {
      cType: cType,
      transactionID: Number(sessionStorage.getItem('transactionID')),
      customNotesType: 0,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      databaseId: Number(this.databaseId)
    }
    this.loaderService.show();
    this.taskService.getAllCustomInfos(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        this.loaderService.hide();
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {
          this.getTagListResponseHolder = response.data;
          if (this.getTagListResponseHolder != null) {
            this.getTagListResponseHolder.map((res: any) => {
              if (res.createdByLastName != null) {
                res.createdByFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.createdByFirstName);
              }
              if (res.createdByLastName != null) {
                res.createdByLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.createdByLastName);
              }
              if (res.customNote != null) {
                res.customNote1 = res.customNote.replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>');
                res.customNoteNew = this.makeLinksClickable(res.customNote1);
              }
              return res;
            });
          }
          this.AllCustomInfoList = this.getTagListResponseHolder;
          if (this.AllCustomInfoList != null) {
            this.AllCustomInfoListShow = true;
          } else {
            this.AllCustomInfoListShow = false;
          }
          this.getCustomInfoTypeList();
        }
        else {
          this.AllCustomInfoList = [];
          this.loaderService.hide();
        }
      } else {
        this.AllCustomInfoList = [];
        this.loaderService.hide();
      }
    });
  }

  makeLinksClickable(text: string): SafeHtml {
    if (!text) {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }

    // Regular expression to match URLs
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    // Replace URLs with anchor tags
    const modifiedText = text.replace(urlRegex, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');

    // Sanitize the resulting HTML
    return this.sanitizer.bypassSecurityTrustHtml(modifiedText);
  }

  addCustomInfo() {
    const dialogRef = this.dialog.open(AddCustomInfoComponent, {
      panelClass: 'custom-modalbox',
      data: {
        moduleName: this.mainModulename,
        folderID: 1,//this.folderId, {{Main=1;Item=2;}}
        documentID: null
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.GetAllCustomInfos();
      }
    });
  }

  onChangeSelectedType(customInfoTypeID: any) {
    var cType = 0;
    if (this.mainModulename == "Core") {
      cType = 1;
    }
    if (this.mainModulename == "Contact") {
      cType = 2;
    }
    if (this.mainModulename == "Company") {
      cType = 3;
    }
    if (customInfoTypeID.value == 0) {
      this.GetAllCustomInfos();
    }
    else {
      var ReqModel = {
        cType: cType,
        transactionID: Number(sessionStorage.getItem('transactionID')),
        customNotesType: Number(customInfoTypeID.value),
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        databaseId: Number(this.databaseId)
      }
      this.loaderService.show();
      this.taskService.getAllCustomInfos(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.getTagListResponseHolder = response;
          this.loaderService.hide();
          if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {
            this.getTagListResponseHolder = response.data;
            if (this.getTagListResponseHolder != null) {
              this.getTagListResponseHolder.map((res: any) => {
                if (res.createdByLastName != null) {
                  res.createdByFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.createdByFirstName);
                }
                if (res.createdByLastName != null) {
                  res.createdByLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.createdByLastName);
                }
                if (res.customNote != null) {
                  res.customNote1 = res.customNote.replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>');
                  res.customNoteNew = this.makeLinksClickable(res.customNote1);
                }
                return res;
              });
            }
            this.AllCustomInfoList = this.getTagListResponseHolder;
            // if(this.AllCustomInfoList!=null){
            //   this.AllCustomInfoListShow=true;              
            // }else{
            //   this.AllCustomInfoListShow=false;            
            // }   
            //this.getCustomInfoTypeList(); 
          }
          else {
            this.AllCustomInfoList = [];
            this.loaderService.hide();
          }
        } else {
          this.AllCustomInfoList = [];
          this.loaderService.hide();
        }
      });
    }
  }

  editCustomInfo(customInfo: any) {
    const dialogRef = this.dialog.open(AddCustomInfoComponent, {
      panelClass: 'custom-modalbox',
      data: {
        moduleName: this.mainModulename,
        folderID: 1,//this.folderId, {{Main=1;Item=2;}}
        documentID: null,
        customInfo: customInfo
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.GetAllCustomInfos();
      }
    });
  }

  deleteCustomInfo(customInfo: any) {
    const message = `Are you sure you want to delete this custom info ?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var cType = 0;
          if (this.mainModulename == "Core") {
            cType = 1;
          }
          if (this.mainModulename == "Contact") {
            cType = 2;
          }
          if (this.mainModulename == "Company") {
            cType = 3;
          }
          let model = {
            customNotesID: [customInfo.customNoteID],
            cType: cType,
            transactionID: Number(sessionStorage.getItem('transactionID')),
            databaseId: Number(this.databaseId),
            organizationID: Number(this.organizationId),
            userID: this.currentUser.UID,
            officeID: this.myOfficeID
          }
          this.taskService.deleteCustomInfo(model).subscribe(response => {
            if (response != undefined) {
              if (response.status == this.statusConst.statusSuccess) {
                this.toastr.success("Custom info Deleted successfully.", '', {
                  timeOut: 3000,
                });
                this.GetAllCustomInfos();
              }
              else {

              }
            }
          });
        }
      } catch (e) {
        //Observable.throw(e);
      }
    });
  }

  // get custom type ==//
  getCustomInfoTypeList() {
    this.CustomInfoType = [];
    this.CustomInfoTypeForFilter = [];
    var ReqModel = {
      databaseId: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      userID: this.currentUser.UID,
    }
    this.taskService.getCustomInfoTypes(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {
          this.CustomInfoType = this.getTagListResponseHolder.data;

          var newlist = [];
          var ReqModel1 = {
            customInfoTypeID: 0,
            customInfoName: "All"
          }
          this.CustomInfoTypeForFilter.push(ReqModel1);
          newlist = this.getTagListResponseHolder.data;
          if (newlist == null) {
            newlist = [];
          }
          for (var i = 0, len = newlist.length; i < len; ++i) {
            this.CustomInfoTypeForFilter.push(newlist[i]);
          }
        }
        else {
        }
      }
    });
  }

}
